// @flow
import React, { Component } from 'react';
import ProgressTab from './ProgressTab';
import {
  checkCompanyDetailsErrors,
  getCompanyDetailsErrors,
  checkMailingErrors,
  getMailingErrors,
  checkAboutErrors,
  getAboutErrors,
  checkContactErrors,
  getContactErrors
} from './validations';
import { type Values } from './handleSubmit';
import { ProgressTabsDiv } from '../../../../components/ProgressTabStyles';

type Props = {
  active: number,
  values: Values,
  dirty: boolean
};

export default class ProgressTabs extends Component<Props> {
  render() {
    const { values } = this.props;
    return (
      <ProgressTabsDiv>
        <ProgressTab
          active={this.props.active === 1}
          index={1}
          label="Company Details"
          shortLabel="Details"
          valid={!checkCompanyDetailsErrors(getCompanyDetailsErrors(values))}
          dirty={this.props.dirty}
        />
        <ProgressTab
          active={this.props.active === 2}
          index={2}
          label="Mailing Address"
          shortLabel="Mailing"
          // $FlowFixMe
          valid={!checkMailingErrors(getMailingErrors(values))}
          dirty={this.props.dirty}
        />
        <ProgressTab
          active={this.props.active === 3}
          index={3}
          label="About The Company"
          shortLabel="About"
          valid={!checkAboutErrors(getAboutErrors(values))}
          dirty={this.props.dirty}
        />
        <ProgressTab
          active={this.props.active === 4}
          index={4}
          label="Contact Details"
          shortLabel="Contact"
          valid={!checkContactErrors(getContactErrors(values))}
          dirty={this.props.dirty}
        />
      </ProgressTabsDiv>
    );
  }
}
